import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenericActivarInactivarEntidadRequest } from '../models/generic-entities.model';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { SharedService } from '../services/shared-service.service';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-activar-inactivar-icono',
  templateUrl: './activar-inactivar-icono.component.html',
  styleUrls: ['./activar-inactivar-icono.component.scss']
})
export class ActivarInactivarIconoComponent implements OnInit {

  @Input() esActivo: boolean = false;
  @Input() registroId: string = '';
  @Input() entidad: string = '';

  @Output() onFinish: EventEmitter<any> = new EventEmitter();

  constructor(private authService: AuthenticationService, private sharedService: SharedService) { }

  ngOnInit() {
  }

  activarInactivarRegistro(nuevoEstado: string)  {
    let request: GenericActivarInactivarEntidadRequest = {
      entidad: this.entidad,
      nuevoEstado: nuevoEstado,
      registroId: this.registroId,
      empleadoId: this.authService.getLoggedUser()?.empleadoId!
    }
    this.sharedService.activarInactivarRegistro(request).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.Response && event.body) {
          this.onFinish.emit(true);
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error(err.error)
      },
    });
  }

  // activarEmpleado(empleado: VmEmpleado) {
  //   empleado.estado = "A";
  //   this.empleadoService.cambiarEstadoEmpleado(empleado).subscribe({
  //     next: (event) => {
  //       if (event.type === HttpEventType.Response && event.body) {
  //         this.getEmpleadosData(this.page, this.pageSize, this.searchTerm, this.filtroEstado);
  //       }
  //     },
  //     error: (err: HttpErrorResponse) => {
  //       console.error(err.error)
  //     },
  //   });
  // }

}
